
Checkout.Session = function(checkout) {
	var session = this;

	this._data = {};
	this.saveRequest = false;
	this.remoteJSON = '';
	this.cookieJSON = '';

	this.cookieFields = {
		'step': 1,
		'shippingServiceGroupID': 1,
		'shippingServiceGroupSet': 1,
		'shippingServiceCode': 1,
		'shippingServiceSet': 1,
		'alt_ship_notes': 1,
		'taxExempt': 1,
		'shippingOverride': 1,
		'shippingOverrideAmt': 1,
		'shipping': {
			'country': 1,
			'zip': 1
		}
	};

	this.init = function() {
		session.load(checkout.config.sessionInit);
	};

	this.load = function(data) {
		session._data = data;
		session.loadCookie();

	};

	this.loadCookie = function() {

		$.each(document.cookie.split(';'), function(i, cookie) {
			var keyVal = cookie.split('=');
			if (keyVal[0].trim() == 'checkout')
				session.cookieJSON = decodeURIComponent(keyVal[1]);
		});

		if (session.cookieJSON)
			$.extend(true, session._data, JSON.parse(session.cookieJSON));
	};

	this.get = function(field) {
		var data = session._data;

		if (!field)
			return $.extend(true, {}, data);

		$.each(field.split(/\./), function(i, f) {
			if (data)
				data = data[f]
			else
				data = undefined;
		});

		if (!data)
			return data;

		if (typeof data == 'object') {
			if (Object.prototype.toString.call(data) === '[object Array]' )
				return $.extend(true, [], data);
			else
				return $.extend(true, {}, data);
		}

		return data;
	};

	this.set = function(data) {

		session.extend(true, session._data, data);

		var cookieData = session.extractCookieData(session._data, session.cookieFields);

		session.saveCookie(cookieData);
	};

	this.extractCookieData = function(data, fields) {
		var cookieData = {};

		for (var field in fields)
			if (data[field])
				if (typeof fields[field] == 'object')
					cookieData[field] = session.extractCookieData(data[field], fields[field]);
				else
					cookieData[field] = data[field];

		return cookieData;
	};

	this.saveCookie = function(cookieData) {
		var newJSON = JSON.stringify(cookieData);

		if (session.cookieJSON != newJSON) {
			session.cookieJSON = newJSON;

			document.cookie =
				'checkout=' + encodeURIComponent(session.cookieJSON)
				+ ';path=/';
		}
	};

	this.saved = function(currentStep) {
		currentStep = (currentStep || false);

		// in the process of saving
		if (session.saveRequest)
			return true;

		var saved = true;

		$.each(checkout.steps, function(i, step) {

			if (
				currentStep
				&& step == currentStep
			)
				return;

			if (
				step != currentStep
				&& checkout[step]
				&& !checkout[step].saved
			)
				saved = false;
		});

		return saved;
	};

	this.setAllData = function() {
		$.each(checkout.steps, function(i, step) {
			if (
				checkout[step]
				&& checkout[step].setSessionData
			)
				checkout[step].setSessionData();
		});
	};

	this.save = function() {

		session.setAllData();

		if (session.saveRequest)
			session.saveRequest.abort();

		$.each(checkout.steps, function(i, step) {
			if (checkout[step])
				checkout[step].saved = true;
		});

		session.saveRequest = checkout.remote.call({
			'type': 'POST', // could be big data
			'data': {
				'step': 'session',
				'action': 'save',
				'session': encodeURIComponent(JSON.stringify(session._data))
			}
		})
			.always(function() {
				session.saveRequest = false;
			});
	};

	this.isLoggedIn = function() {
		if (session._data.loggedIn)
			return true;

		return false;
	};

	// Modified jQuery's extend so that arrays always get the new data
	this.extend = function() {
		var src, copyIsArray, copy, name, options, clone,
			target = arguments[0] || {},
			i = 1,
			length = arguments.length,
			deep = false;

		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}

		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
			target = {};
		}

		// extend jQuery itself if only one argument is passed
		if ( length === i ) {
			target = this;
			--i;
		}

		for ( ; i < length; i++ ) {
			// Only deal with non-null/undefined values
			if ( (options = arguments[ i ]) != null ) {

				// Array values always get the new data
				if (jQuery.isArray(target) && jQuery.isArray(options)) {
					target = jQuery.extend(deep, [], options);
					continue;
				}

				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];

					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}

					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray(src) ? src : [];

						} else {
							clone = src && jQuery.isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						target[ name ] = session.extend( deep, clone, copy );

					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}

		// Return the modified object
		return target;
	};

	this.init();
};

